module.exports = __webpack_public_path__ + "img/index-manual-step-4@3x.943596a6.png";